// src/pages/Resources/ApiPage.js
import React from 'react';
import { Container, Typography, Paper, Box, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Link } from '@mui/material';

const RENGIGS = {
  green: '#2E7D32',
  lightGreen: '#4CAF50',
  lime: '#CDDC39',
  dark: '#1A2A3A',
  light: '#F8FAFC',
  border: '#E1E9F0',
  gradient: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 40%, #8BC34A 70%, #CDDC39 100%)',
};

const ApiPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: `1px solid ${RENGIGS.border}` }}>
        <Typography variant="h3" sx={{ fontWeight: 900, color: RENGIGS.dark, mb: 1 }}>
          API Overview
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Programmatic access to Rengigs data and functionality.
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Typography variant="body1" paragraph>
          The Rengigs API is built with REST principles and returns JSON responses. All requests require authentication using Bearer tokens (JWT).
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>Base URL</Typography>
        <Paper sx={{ p: 2, bgcolor: '#1e1e1e', color: '#d4d4d4', fontFamily: 'monospace', mb: 3 }}>
          https://api.rengigs.com/v1/
        </Paper>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>Authentication</Typography>
        <Typography variant="body1" paragraph>
          Include your JWT token in the Authorization header:
        </Typography>
        <Paper sx={{ p: 2, bgcolor: '#1e1e1e', color: '#d4d4d4', fontFamily: 'monospace', mb: 3 }}>
          Authorization: Bearer &lt;your_token&gt;
        </Paper>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>Endpoints</Typography>
        <TableContainer component={Box} sx={{ mb: 3 }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: RENGIGS.light }}>
                <TableCell><strong>Method</strong></TableCell>
                <TableCell><strong>Endpoint</strong></TableCell>
                <TableCell><strong>Description</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow><TableCell>GET</TableCell><TableCell>/problems/</TableCell><TableCell>List problems</TableCell></TableRow>
              <TableRow><TableCell>POST</TableCell><TableCell>/problems/</TableCell><TableCell>Create a problem</TableCell></TableRow>
              <TableRow><TableCell>GET</TableCell><TableCell>/solutions/</TableCell><TableCell>List solutions</TableCell></TableRow>
              <TableRow><TableCell>POST</TableCell><TableCell>/solutions/</TableCell><TableCell>Create a solution</TableCell></TableRow>
              <TableRow><TableCell>GET</TableCell><TableCell>/organizations/</TableCell><TableCell>List organizations</TableCell></TableRow>
              <TableRow><TableCell>POST</TableCell><TableCell>/billing/checkout/</TableCell><TableCell>Create Stripe checkout session</TableCell></TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          For full documentation, visit our <Link href="/docs" sx={{ color: RENGIGS.green }}>Developer Portal</Link>.
        </Typography>
      </Paper>
    </Container>
  );
};

export default ApiPage;